<div class="m-2">
  <h2 class="ap-blue">{{ 'ml_144113' | translate }}</h2>

  <div mat-dialog-content>
    <app-data-grid [dataSource$]="dataSource$" [columnsDef]="terminalListDataGridColumnDef"></app-data-grid>
  </div>

  <div mat-dialog-actions class="row mt-2 p-2 justify-content-end">
    <div class="col-auto align-self-end">
      <button class="button--default" [mat-dialog-close]="true">{{ 'ml_143929' | translate}}</button>
    </div>
  </div>
</div>
